import styled from 'styled-components';

const StyledHideCalendarLabel = styled.div`
  font-size: .85rem;
  font-weight: 600;
  line-height: 1.2;
`;

const StyledHideCalendarButton = styled.div`
  text-align: center;
  padding-right: 0px;
  user-select: none;
  cursor: pointer;
  transition: color .15s ease-in-out;

  :hover {
    color: #747474;
  }
`;

export {
  StyledHideCalendarButton,
  StyledHideCalendarLabel,
};